import { ComplianceItem } from '../../apis/settings/settingsComplianceItem.interfaces';

export const mockComplianceDetails: ComplianceItem = {
  id: '1',
  title: 'Compliance Item 1',
  description: 'Description 1',
  status: 'PENDING',
  riskLevel: 'LOW',
  priority: 'LOW',
  jurisdiction: 'IN',
  authority: 'CBSE',
  sourceRefs: [],
  effectiveDate: '2025-01-01',
  dueDate: '2025-01-01',
  recurrence: {
    frequency: 'DAILY',
    interval: 1,
  },
  lastCompletedAt: '2025-01-01',
  nextDueDate: '2025-01-01',
  owners: [
    {
      userId: '1',
      role: 'Owner',
      name: 'Owner 1',
    },
  ],
  relatedEntity: {
    type: 'SCHOOL',
    id: '1',
    name: 'School 1',
  },
  checklist: [],
  documents: [],
  evidenceItems: [],
  activityLog: [],
  tags: ['tag1', 'tag2'],
  metadata: {
    key1: 'value1',
    key2: 'value2',
  },
  createdAt: '2025-01-01',
  updatedAt: '2025-01-01',
};
